<template>
  <el-tabs v-model="activeName" class="zg-tabs" @tab-click="onClickTab">
    <el-tab-pane v-for="(item, i) in tabArr" :key="i" :name="i.toString()">
      <span slot="label" class="f-16">
        {{ item.label }}
        <span v-if="item.tip !== 0" class="c-main">{{ item.tip }}</span>
        <template v-if="item.tipText">
          <el-tooltip class="item" effect="dark" :content="item.tipText" placement="bottom">
            <span @click.stop @mouseover.stop class="tool-tip-icon">i</span>
          </el-tooltip>
        </template>
      </span>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: 'ZgTabs',
  components: {},
  props: {
    tabArr: {
      required: true,
      type: Array,
      default: () => [{ label: '全部提单', tip: 0 }]
    }
  },
  data() {
    return {
      activeName: '0'
    }
  },
  mounted() {},
  methods: {
    onClickTab() {
      this.$emit('onClickTab', this.activeName)
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-tip-icon {
  width: 16px;
  height: 16px;
  color: #fff;
  line-height: 16px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 50%;
  display: inline-block;
  background: #ccc;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  &:hover {
    background: #f0242e;
  }
}
</style>
